// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__1tr71","errorLogs":"styles_errorLogs__3WCm_"};